import { DomainPreferences } from '../../api/types';
import { Months } from '../../common/components/timeslider/types';
import { Timestamp } from '../../types';
import {
  addMonth,
  addYear,
  fiscalYearStart,
  format,
  getFiscalQuarter,
  getFiscalYear,
  getMomentDate,
  monthEnd,
  monthStart,
  now as nowDate,
} from '../../utils-date';

// TODO: review this as we won't be able to store logic in json settings
// we should have two options: relative (e.g. last 3 months) or absolute timeframes (e.g. 2023 to 2024)
export class StoryboardDateUtils {
  constructor(public readonly now: Timestamp = nowDate()) {}
  xYearsAgo = (x: number) => {
    return addYear(this.now, -x);
  };
  startOfFiscalYear = (domainPreferences: DomainPreferences, current = monthEnd(this.now)) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return format(fiscalYearStart(current, finMonth));
  };
  fiscalYearStart = (domainPreferences: DomainPreferences, current = monthEnd(this.now)) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return format(fiscalYearStart(current, finMonth));
  };
  fiscalYear = (domainPreferences: DomainPreferences) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return getFiscalYear(this.now, finMonth);
  };
  fiscalQuarter = (domainPreferences: DomainPreferences) => {
    const finMonth = domainPreferences.finYearStartMonth ?? Months.January;
    return getFiscalQuarter(this.now, finMonth);
  };
  get lastYear() {
    return addYear(this.now, -1);
  }
  get lastYearEndOfMonth() {
    return format(monthEnd(this.lastYear));
  }
  get nowEndOfMonth() {
    return format(monthEnd(this.now));
  }
  get lastMonth() {
    return addMonth(this.now, -1);
  }
  get lastMonthEndOfMonth() {
    return format(monthEnd(this.lastMonth));
  }
  get lastMonthLastYear() {
    return addYear(this.lastMonth, -1);
  }
  get lastMonthLastYearEndOfMonth() {
    return format(monthEnd(this.lastMonthLastYear));
  }
  get twelveMonthsAgoFromLastMonth() {
    return addMonth(this.lastMonth, -11);
  }
  get twelveMonthsAgoFromLastMonthStartOfMonth() {
    return format(monthStart(this.twelveMonthsAgoFromLastMonth));
  }
  get twelveMonthsAgoFromLastMonthEndOfMonth() {
    return format(monthEnd(this.twelveMonthsAgoFromLastMonth));
  }
  get twelveMonthsAgoFromLastMonthLastYear() {
    return addYear(this.twelveMonthsAgoFromLastMonth, -1);
  }
  get twelveMonthsAgoFromLastMonthLastYearEndOfMonth() {
    return format(monthEnd(this.twelveMonthsAgoFromLastMonthLastYear));
  }
  get startOfLastYear() {
    return format(getMomentDate(this.lastYear).startOf('year').valueOf());
  }
}
